import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { getRuolo } from '../hooks/useCurrentUser';
import { getPermessiRuolo } from '../services/ruoliApi';

const PermessiContext = createContext({
    permessi: [],
    hasPermesso: () => true,
    loading: true,
    reload: () => {},
});

export const PermessiProvider = ({ children }) => {
    const [permessi, setPermessi] = useState([]);
    const [loading, setLoading] = useState(true);

    const carica = useCallback(async () => {
        const token = localStorage.getItem('token');
        if (!token) {
            setPermessi([]);
            setLoading(false);
            return;
        }
        const ruolo = getRuolo();
        if (ruolo === 'admin') {
            setPermessi(['*']);
            setLoading(false);
            return;
        }
        try {
            const data = await getPermessiRuolo(ruolo);
            setPermessi(data.permessi || []);
        } catch {
            setPermessi([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        carica();
        window.addEventListener('auth-changed', carica);
        return () => window.removeEventListener('auth-changed', carica);
    }, [carica]);

    const hasPermesso = useCallback((sezione) => {
        if (permessi.includes('*')) return true;
        return permessi.includes(sezione);
    }, [permessi]);

    return (
        <PermessiContext.Provider value={{ permessi, hasPermesso, loading, reload: carica }}>
            {children}
        </PermessiContext.Provider>
    );
};

export const usePermessi = () => useContext(PermessiContext);

// Lista completa delle sezioni configurabili
export const SEZIONI_PERMESSI = [
    { id: 'clienti',        label: 'Clienti' },
    { id: 'preventivi',     label: 'Preventivi' },
    { id: 'ordini',         label: 'Ordini' },
    { id: 'produzione',     label: 'Produzione' },
    { id: 'magazzino',      label: 'Magazzino' },
    { id: 'listini',        label: 'Listini' },
    { id: 'fatturazioni',   label: 'Fatturazione' },
    { id: 'statistiche',    label: 'Statistiche' },
    { id: 'preventivatore', label: 'Preventivatore' },
    { id: 'task',           label: 'Task' },
    { id: 'configurazione', label: 'Configurazione' },
    { id: 'catalogo',       label: 'Catalogo' },
];
